import React from 'react';
import { connect } from 'react-redux';
import i18n from 'util/i18n';
import { rootSelectors } from '@redux/modules/selectors';
import * as formTypes from 'constants/formTypes';
import './Help.scss';

const helpBackgroundClass = 'help-content-background';
const helpContentsClass = 'help-contents-class';

export class Help extends React.Component {
  constructor(props) {
    super(props);
  }

  isSF86 = () => this.props.formType === formTypes.SF86;

  getSF86Guide = () => (this.isSF86() ? (
    <div className="table-one" id="sf86Guide">
      <div className="intro">
        {i18n.m('help.sf86Guide')}
        <a href="/docs/eAppGuideSF86v2.pdf" target="_blank" rel="noopener noreferrer" download>
          Download SF86 Guide
        </a>
        {i18n.m('help.linebreak')}
      </div>
    </div>
  ) : null);

  getTableOfContents = () => (
    <div className="table-of-contents">
      <p className="table-title">Contents</p>
      <ul className="table-list">
        {this.isSF86() && <li><a href="#sf86Guide">SF86 Guide</a></li>}
        <li><a href="#helpIcon">Help Icon</a></li>
        <li><a href="#navigation-menu">The Navigation Menu</a>
          <ul>
            <li><a href="#hamburger-icon">1. The Hamburger Icon</a></li>
            <li><a href="#sections-complete">2. Sections Complete</a></li>
            <li><a href="#review">3. Section Review</a></li>
            <li><a href="#reviewSubmit">4. Final Review and Submit</a></li>
          </ul>
        </li>
        <li><a href="#support">Need Additional Support?</a></li>
      </ul>
    </div>
  );

  render() {
    return (
      <div className="token-error login eapp-core" id="login">
        <div className="eapp-structure-row">
          <div id="seal-header" className="seal-header">
            <div className="eapp-structure-left eapp-logo" id="logo">
              <img src="/img/dcsa-logo.png" alt="National Background Investigation Services" />
              <h3 className="help-header-lg">{i18n.t('login.token.heading')}</h3>
            </div>
          </div>
        </div>
        <div className={helpBackgroundClass}>
          <div className={helpContentsClass}>
            <div className="table-one">
              <div id="intro">
                {i18n.m('help.intro')}
                <a
                  href="/help/video"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="video-link"
                >Click here to watch the Introduction to eApp video.
                </a>
                {i18n.m('help.linebreak')}
              </div>
              {this.getTableOfContents()}

              {/* Main body of content here */}
              {this.getSF86Guide()}
              <div className="section" id="helpIcon">
                <div className="section-text">{i18n.m('help.helpIcon')}</div>
                <div className="picture-box">
                  <a href="/img/helpicon.png" target="_blank" rel="noopener noreferrer"><img src="/img/helpicon.png" /></a>
                  <div className="picture-text">Help Icon</div>
                </div>
              </div>
              <div id="navigation-menu">
                {i18n.m('help.navigation')}
                <ul>
                  <div className="section" id="hamburger-icon">
                    <div className="section-text">{i18n.m('help.hamburger')}</div>
                    <div className="picture-box">
                      <a href="/img/hamburger.png" target="_blank" rel="noopener noreferrer"><img src="/img/hamburger.png" /></a>
                      <div className="picture-text">Hamburger Menu</div>
                    </div>
                  </div>
                  <div className="section" id="sections-complete">
                    <div className="section-text">{i18n.m('help.sectionsComplete')}</div>
                    <div className="picture-box">
                      <a href="/img/formcompleted.png" target="_blank" rel="noopener noreferrer"><img src="/img/formcompleted.png" /></a>
                      <div className="picture-text">All sections, individual section, and subsection marked as complete</div>
                    </div>
                  </div>
                  <div className="section" id="review">
                    <div className="section-text">{i18n.m('help.review')}</div>
                    <div className="picture-box">
                      <a href="/img/sectionreview.png" target="_blank" rel="noopener noreferrer"><img src="/img/sectionreview.png" /></a>
                      <div className="picture-text">Navigation to the Section Review Page</div>
                    </div>
                  </div>
                  <div className="section" id="reviewSubmit">
                    <div className="section-text">{i18n.m('help.reviewSubmit')}</div>
                    <div className="picture-box">
                      <a href="/img/field-errors.png" target="_blank" rel="noopener noreferrer"><img src="/img/field-errors.png" /></a>
                      <div className="picture-text">Fields with errors will be marked red</div>
                    </div>
                  </div>
                </ul>
              </div>
              <div id="support">{i18n.m('help.support')}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formType: rootSelectors.application.getFormType(state),
});

export default connect(mapStateToProps)(Help);
